import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { SpinningLoader } from "../SpinningLoader";
export var PageTitle = function (_a) {
    var title = _a.title, actions = _a.actions, isLoading = _a.isLoading;
    return (_jsxs(Stack, { direction: "row", alignItems: "center", gap: 2, mb: title ? 2 : 0, children: [title && _jsx(Typography, { variant: "h2", children: title }), actions, isLoading && _jsx(SpinningLoader, {})] }));
};
